import { IForm } from '@/components/types'
import { useSearchDateShortcut, useSearchDays } from '@/hooks/useSearch'

const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      placeholder: '请选择直播间',
      clearable: true
    },
    {
      field: 'accessTime',
      type: 'dateTimePicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      label: '持续听课天数',
      type: 'select',
      field: 'continueAttend',
      placeholder: '请选择天数',
      options: [
        { title: '≥ 3天', value: '' },
        { title: '≥ 4天', value: '4' },
        { title: '≥ 5天', value: '5' },
        { title: '≥ 6天', value: '6' },
        { title: '≥ 7天', value: '7' },
        { title: '≥ 8天', value: '8' },
        { title: '≥ 9天', value: '9' },
        { title: '≥ 10天', value: '10' }
      ],
      clearable: true
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门',
      clearable: true
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
